import { useRoute } from 'vue-router'

/* Stores */
import { useSlidersStore } from '@/store/sliders/sliders'

/* Types */
import { Popup } from '@/types/api/api-v3/popup-working'

export const usePopupFetch = () => {
  const slidersStore = useSlidersStore()
  const route = useRoute()

  const popupsWorking = computed(() => slidersStore.popupsOfWorking)

  onMounted(async () => {
    const isBasket = route.path.includes('basket')

    await slidersStore.fetchPopupsWorking(isBasket)

    // @ts-ignore
    if (popupsWorking.value.popups && popupsWorking.value.popups?.length) {
      slidersStore.setPopupWorking({
        ...popupsWorking.value,
        callPopup: popupsWorking.value.popups[0],
        visible: true,
      })
    }
  })
}

export const usePopupDialog = () => {
  const slidersStore = useSlidersStore()

  const popupsWorking = computed(() => slidersStore.popupsOfWorking)

  const callPopup = computed<null | Popup>(() => popupsWorking.value.callPopup)

  const closePopupWorking = () => {
    // узнаем index попапа, чтобы дальше вызвать другие попапы
    let indexPopup = popupsWorking?.value?.popups
      ? // @ts-ignore
        popupsWorking.value.popups.findIndex(
          // @ts-ignore
          (popup: Popup) => popup.id === callPopup?.value?.id,
        )
      : null

    // если вызванный попап не последний, то показываем следующий попап

    // @ts-ignore
    if (indexPopup !== popupsWorking?.value?.popups?.length - 1) {
      slidersStore.setPopupWorking({
        ...popupsWorking.value,
        // @ts-ignore
        callPopup: popupsWorking.value?.popups[++indexPopup],
      })
    } else {
      slidersStore.setPopupWorking({
        popups: null,
        visible: false,
        callPopup: null,
      })
    }
  }

  return {
    popupsWorking,
    closePopupWorking,
    callPopup,
  }
}
